<template>
  <div>
    <!-- 리스트 정보 -->
    <div class="listInfo">
      <div class="title" v-if="rankData.length !== 0">{{currentYear}} ACL 조별 예선</div>
      <div class="sort">
        <span class="infoItem">
          <select v-model="currentYear" class="select">
            <option value="">년도선택</option>
            <option
                v-for="(y, i) in year"
                :key="i"
                :value="y.id">
              {{ y.name }}
            </option>
          </select>
        </span>
      </div>
    </div>
    <!-- //리스트 정보 -->
    <div class="rankingTable smallTable" v-if="state">
      <table style="min-width: 420px;">
        <colgroup>
          <col style="width: 8%;">
          <col style="width: auto;">
          <col style="width: 9%;">
          <col style="width: 9%;">
          <col style="width: 9%;">
          <col style="width: 9%;">
          <col style="width: 9%;">
          <col style="width: 9%;">
          <col style="width: 9%;">
          <col style="width: 9%;">
        </colgroup>
        <thead >
        <tr>
          <th>순위</th>
          <th>팀</th>
          <th>승점</th>
          <th>승</th>
          <th>무</th>
          <th>패</th>
          <th>득점</th>
          <th>실점</th>
          <th>득실</th>
          <th>경기</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(data, i) in rankData" :key="i" :class="{active: data.team_name_front === '전북'}">
          <td class="bold">{{data.rank}}</td>
          <td class="bold" style="text-align:left;">
            <img :src="data.teamLogoImg">
            {{data.team_name}}
          </td>
          <td class="bold">{{data.gain_point}}</td>
          <td>{{data.win_cnt}}</td>
          <td>{{data.tie_cnt}}</td>
          <td>{{data.loss_cnt}}</td>
          <td>{{data.gain_goal}}</td>
          <td>{{data.loss_goal}}</td>
          <td>{{data.gap_cnt}}</td>
          <td>{{data.game_count}}</td>
        </tr>
        </tbody>
      </table>
      <!--      <p class="updateat" v-if="rankData.length !== 0">업데이트 일시 : 2022년 10월 16일</p>-->
    </div>
    <div class="noData" v-if="state && rankData.length === 0">데이터가 없습니다</div>
    <div v-if="!state">
      <img :src="img" alt='acl_2425_tournament'/>
    </div>
  </div>
</template>
<script>
import http from "@/api"
import imgPath from "@/library/imgPath"

export default  {
  name: 'MatchAclRanking',
  created() {
    const paramsYear = this.$store.state.params && this.$store.state.params.year
    const thisYear = this.$store.state.thisYear
    const count = thisYear - this.yearStart
    // 리스트 년도 필터 생성
    for (let i = 0; i <= count; i++) {
      const year = thisYear - i
      this.year.push({
        id: year,
        name: year
      })
    }
    this.currentYear = paramsYear || thisYear
    this.img = `${imgPath.imgPath.jbhd_s3}uploadFile/match/acl_2425_tournament.jpeg`
  },
  watch: {
    currentYear() {
      this.init('year')
    }
  },
  data () {
    return {
      currentYear: '',
      yearStart: 2023, // 필터 시작 년도
      year: [],
      rankData : [],
      isActive : null,
      state: false,
      img: ''
    }
  },
  methods: {
    async init (type) {
      const params = {
        params: {
          year: ''
        }
      }
      if(type === 'year'){
        params.params.year = this.currentYear
        this.state = this.currentYear !== 2025; //fix---추후제거
      }

      const rank = await http.get('/match/acl_rank?type=all',params)
      rank.data.data.map(row => {
        row.team_name_front = row.team_name.substr(0,2)
        row.team_name_back = row.team_name.substr(2)
        row.teamLogoImg = imgPath.setTeamLogo(row.team_id)
      })
      this.rankData = rank.data.data
    }
  }
}

</script>
